import React, { Component } from "react";

class Question extends Component {
  state = {};
  render() {
    return (
      <div className="question_only">
        <label className="title">{this.props.question.user.username}</label>
        <label>{this.props.question.name}</label>
        {this.renderImage()}
      </div>
    );
  }
  renderImage() {
    if (this.props.question.question_type === "image") {
      return <img src={this.props.question.image_url_medium} alt="question" />;
    }
    return <label />;
  }
}

export default Question;



// WEBPACK FOOTER //
// ./src/components/questions/question.jsx